import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';

const LOCAL_PREFIX = 'EVENT_ROOT.SHARED.DESCRIPTION.TOOLBAR';

const EDITOR_LABEL_KEYS: Record<string, string> = {
  bold: 'BOLD',
  italic: 'ITALIC',
  underline: 'UNDERLINE',
  strike: 'STRIKE',
  code: 'CODE',
  blockquote: 'BLOCKQUOTE',
  bullet_list: 'BULLET_LIST',
  ordered_list: 'ORDERED_LIST',
  heading: 'HEADING',
  h1: 'H1',
  h2: 'H2',
  h3: 'H3',
  h4: 'H4',
  h5: 'H5',
  h6: 'H6',
  align_left: 'ALIGN_LEFT',
  align_center: 'ALIGN_CENTER',
  align_right: 'ALIGN_RIGHT',
  align_justify: 'ALIGN_JUSTIFY',
  text_color: 'TEXT_COLOR',
  background_color: 'BACKGROUND_COLOR',
  horizontal_rule: 'HORIZONTAL_RULE',
  format_clear: 'FORMAT_CLEAR',
  indent: 'INDENT',
  outdent: 'OUTDENT',
  superscript: 'SUPERSCRIPT',
  subscript: 'SUBSCRIPT',
  undo: 'UNDO',
  redo: 'REDO',
  insertLink: 'INSERT_LINK',
  removeLink: 'REMOVE_LINK',
  insertImage: 'INSERT_IMAGE',
  url: 'URL',
  text: 'TEXT',
  openInNewTab: 'OPEN_IN_NEW_TAB',
  insert: 'INSERT',
  altText: 'ALT_TEXT',
  title: 'TITLE',
  remove: 'REMOVE',
  enterValidUrl: 'ENTER_VALID_URL',
};

export function createEditorLocals(
  translate: TranslateService,
): Record<string, Observable<string>> {
  return Object.fromEntries(
    Object.entries(EDITOR_LABEL_KEYS).map(([local, key]) => [
      local,
      translate.stream(`${LOCAL_PREFIX}.${key}`),
    ]),
  );
}
